module.exports = __webpack_public_path__ + "img/seccion4.5.1f31ab5e.png";